var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 61,
    viewBox: "0 0 118 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M117.941 18.1431H0V59.8624H117.941V18.1431Z",
    fill: "#FF9274"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.629 30.3345H43.8677V49.7094H111.629V30.3345Z",
    fill: "#E85931"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M110.139 31.7422H45.3569V48.301H110.139V31.7422Z",
    fill: "#9FECFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.0629 44.8174L80.7713 31.7426H79.2177L68.0629 43.219V44.8174ZM68.0629 41.6202V38.4234L74.5569 31.7422H77.6641L68.0629 41.6202ZM68.0629 36.825V35.2266L71.4493 31.7422H73.0029L68.0629 36.825ZM64.6765 48.3015L68.0629 44.8174V43.219L63.123 48.3015H64.6765ZM68.0629 35.227V36.8254L56.9082 48.3019H55.355L68.0629 35.227ZM68.0629 38.4234V41.6202L61.569 48.3015H58.4618L68.0629 38.4234Z",
    fill: "#DEF8FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2959 30.3345H21.04V59.8626H38.2959V30.3345Z",
    fill: "#E85931"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.8063 31.6523H22.5298V59.8624H36.8063V31.6523Z",
    fill: "#9FECFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M117.941 57.9702H36.8062V59.8835H117.941V57.9702Z",
    fill: "#E85931"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5298 30.3345H5.27393V59.8626H22.5298V30.3345Z",
    fill: "#E85931"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0402 31.6523H6.76416V59.8624H21.0402V31.6523Z",
    fill: "#9FECFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76465 50.0709L21.0407 35.3831V33.8677L6.76465 48.5555V50.0709Z",
    fill: "#DEF8FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76465 54.6167L21.0407 39.9285V36.8979L6.76465 51.5862V54.6167Z",
    fill: "#DEF8FF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.76465 57.6476L21.0407 42.9598V41.4443L6.76465 56.1321V57.6476Z",
    fill: "#DEF8FF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M19.02 13.5669H15.6875V19.7748H19.02V13.5669Z",
    fill: "#FF9274"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7641 13.5669H43.4316V19.7748H46.7641V13.5669Z",
    fill: "#FF9274"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5098 13.5669H71.1772V19.7748H74.5098V13.5669Z",
    fill: "#FF9274"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M102.255 13.5669H98.9224V19.7748H102.255V13.5669Z",
    fill: "#FF9274"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M117.941 0.742188H0V14.0245H117.941V0.742188Z",
    fill: "#FF9274"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.941 18.1431H0V23.5411H117.941V18.1431Z",
    fill: "#21839C"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2883 47.605H48.2109V57.7027H49.2883V47.605Z",
    fill: "#4C6308"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.8602 60.9932H51.4112L52.8842 54.4131H44.3872L45.8602 60.9932Z",
    fill: "#FFD873"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.621 47.1602C48.7172 47.1602 50.4269 45.4012 50.4269 43.2449C50.4269 41.0886 48.7172 39.3296 46.621 39.3296C44.5251 39.3296 42.8154 41.0886 42.8154 43.2449C42.8154 45.4016 44.5247 47.1602 46.621 47.1602Z",
    fill: "#729116"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2792 50.2172C47.3754 50.2172 49.0851 48.4586 49.0851 46.3019C49.0851 44.1452 47.3754 42.3862 45.2792 42.3862C43.1833 42.3862 41.4736 44.1452 41.4736 46.3019C41.474 48.4586 43.1833 50.2172 45.2792 50.2172Z",
    fill: "#729116"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6365 51.0077C53.7323 51.0077 55.442 49.2491 55.442 47.0924C55.442 44.9358 53.7323 43.1768 51.6365 43.1768C49.5403 43.1768 47.8306 44.9358 47.8306 47.0924C47.831 49.2491 49.5403 51.0077 51.6365 51.0077Z",
    fill: "#729116"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8948 45.5015C52.9906 45.5015 54.7003 43.7425 54.7003 41.5862C54.7003 39.4295 52.9906 37.6709 50.8948 37.6709C48.7986 37.6709 47.0889 39.4299 47.0889 41.5862C47.0889 43.7425 48.7986 45.5015 50.8948 45.5015Z",
    fill: "#729116"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.5217 48.7144C52.0042 48.7144 53.2129 47.4708 53.2129 45.9456C53.2129 44.4208 52.0042 43.1772 50.5217 43.1772C49.0393 43.1772 47.8306 44.4208 47.8306 45.9456C47.831 47.4704 49.0397 48.7144 50.5217 48.7144Z",
    fill: "#A8C455"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6234 47.7085C48.1058 47.7085 49.3146 46.4649 49.3146 44.9398C49.3146 43.415 48.1058 42.1714 46.6234 42.1714C45.1414 42.1714 43.9326 43.415 43.9326 44.9398C43.933 46.4649 45.1418 47.7085 46.6234 47.7085Z",
    fill: "#A8C455"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.5413 46.2501C49.0233 46.2501 50.232 45.0065 50.232 43.4818C50.232 41.957 49.0233 40.7134 47.5413 40.7134C46.0588 40.7134 44.8501 41.957 44.8501 43.4818C44.8505 45.0061 46.0592 46.2501 47.5413 46.2501Z",
    fill: "#A8C455"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.8592 44.8414C52.3417 44.8414 53.5504 43.5978 53.5504 42.0731C53.5504 40.5483 52.3417 39.3047 50.8592 39.3047C49.3772 39.3047 48.1685 40.5483 48.1685 42.0731C48.1685 43.5978 49.3772 44.8414 50.8592 44.8414Z",
    fill: "#A8C455"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M108.572 47.605H107.494V57.7027H108.572V47.605Z",
    fill: "#4C6308"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.922 60.9932H105.371L103.898 54.4131H112.395L110.922 60.9932Z",
    fill: "#FFD873"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.766 45.7876C112.862 45.7876 114.572 44.0286 114.572 41.8723C114.572 39.7156 112.862 37.957 110.766 37.957C108.67 37.957 106.96 39.716 106.96 41.8723C106.961 44.029 108.67 45.7876 110.766 45.7876Z",
    fill: "#729116"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.38 51.4483C112.476 51.4483 114.185 49.6892 114.185 47.533C114.185 45.3767 112.476 43.6177 110.38 43.6177C108.284 43.6177 106.574 45.3767 106.574 47.533C106.574 49.6897 108.284 51.4483 110.38 51.4483Z",
    fill: "#729116"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.146 51.0072C107.242 51.0072 108.952 49.2486 108.952 47.0919C108.952 44.9353 107.242 43.1763 105.146 43.1763C103.05 43.1763 101.34 44.9353 101.34 47.0919C101.341 49.2486 103.05 51.0072 105.146 51.0072Z",
    fill: "#729116"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.888 45.5015C107.984 45.5015 109.694 43.7425 109.694 41.5862C109.694 39.4295 107.984 37.6709 105.888 37.6709C103.792 37.6709 102.083 39.4299 102.083 41.5862C102.083 43.7425 103.792 45.5015 105.888 45.5015Z",
    fill: "#729116"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.261 48.7144C107.743 48.7144 108.952 47.4708 108.952 45.9456C108.952 44.4208 107.743 43.1772 106.261 43.1772C104.779 43.1772 103.57 44.4208 103.57 45.9456C103.57 47.4704 104.779 48.7144 106.261 48.7144Z",
    fill: "#A8C455"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.036 48.9395C110.518 48.9395 111.727 47.6959 111.727 46.1707C111.727 44.6459 110.518 43.4023 109.036 43.4023C107.553 43.4023 106.345 44.6459 106.345 46.1707C106.345 47.6959 107.553 48.9395 109.036 48.9395Z",
    fill: "#A8C455"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M109.846 44.8649C111.328 44.8649 112.537 43.6213 112.537 42.0965C112.537 40.5717 111.328 39.3281 109.846 39.3281C108.364 39.3281 107.155 40.5717 107.155 42.0965C107.155 43.6213 108.364 44.8649 109.846 44.8649Z",
    fill: "#A8C455"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M105.924 44.8414C107.406 44.8414 108.614 43.5978 108.614 42.0731C108.614 40.5483 107.406 39.3047 105.924 39.3047C104.441 39.3047 103.232 40.5483 103.232 42.0731C103.232 43.5978 104.441 44.8414 105.924 44.8414Z",
    fill: "#A8C455"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.3128 44.8174L104.021 31.7426H102.468L91.3128 43.219V44.8174ZM91.3128 41.6202V38.4234L97.8068 31.7422H100.914L91.3128 41.6202ZM91.3128 36.825V35.2266L94.6992 31.7422H96.2528L91.3128 36.825ZM87.9261 48.3015L91.3124 44.8174V43.219L86.3725 48.3015H87.9261ZM91.3128 35.227V36.8254L80.1581 48.3019H78.6045L91.3128 35.227ZM91.3128 38.4234V41.6202L84.8189 48.3015H81.7117L91.3128 38.4234Z",
    fill: "#DEF8FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5298 50.0709L36.8063 35.3831V33.8677L22.5298 48.5555V50.0709Z",
    fill: "#DEF8FF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5298 54.6167L36.8063 39.9285V36.8979L22.5298 51.5862V54.6167Z",
    fill: "#DEF8FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5298 57.6476L36.8063 42.9598V41.4443L22.5298 56.1321V57.6476Z",
    fill: "#DEF8FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2742 57.9702H0V59.8835H5.2742V57.9702Z",
    fill: "#E85931"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M115.866 3.07764H2.0752V11.6906H115.866V3.07764Z",
    fill: "#FFD1C4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.07b7b0c5de9541df864f0cf9160d47a7.svg";
export { ForwardRef as ReactComponent };